import styles from './index.modules.sass';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const Wrapper = ({ show, children }) => {
  const wrapperClass = cx({
    wrapper: true,
    show,
  });
  return <div className={wrapperClass}>{children}</div>;
};

export default Wrapper;
